class SiteLabelInputLanguage
    extends SiteLabel<LanguageValues, ISiteLabelConfig> {

    private readonly _input: IQueryElement;
    private readonly _container: IQueryElement;
    private _selectedLanguage: Languages;
    private _value: LanguageValues | null = null;

    constructor(card: SiteCard, model: ISiteModel, modelData: ISiteModel, element: HTMLElement) {
        super(card, model, modelData, element);

        let input = this.query("input, textarea").first();
        if(input === null)
            throw "Missing element.";

        this._input = input;

        this._container = QueryElement.QueryElement('div')
            .addClass("languages")
            .addClass("popout")
            .addClass("popout-" + this.config.popout)
            .addClass("show");
        
        let config = this.getCard().SiteConfig;
        this._selectedLanguage = config.language;

        this.append(this._container);
    }
    
    getInput() {
        return this._input;
    }

    defaultConfig(): ISiteLabelConfig {
        return {
            popout: "normal",
            scroll: "top"
        }
    }
    setLanguage(language:Languages) {
        this.makeInactive();
        
        this._selectedLanguage = language;

        this._container.clear();
        this.makeActive();
        this.setValue(this._value);
    }
    drawLanguages() {
        let config = this.getCard().SiteConfig;
        for(let x in config.languageNames)
        {
            let language = x as Languages;

            let title = config.languageNames[language] as string;
            let button = new SiteButton({
                    title: title
                })
                .appendTo(this._container);
            button.on("click", (e) => {
                this.setLanguage(language)
                e.stop();
            });

            if(x == this._selectedLanguage)
                button.addClass("active");
        }
    }
    makeActive() {
        if(super.makeActive()) {
            this.drawLanguages();
            this._input.select();
            return true;
        }
        return false;
    }
    makeInactive() {
        if(this._value === null)
            this._value = {};

        let inputValue = this._input.getVal();
        if (inputValue == null || inputValue == "")
            delete this._value[this._selectedLanguage];
        else
            this._value[this._selectedLanguage] = inputValue;

        super.makeInactive();
        this._container.clear();
    }
    setValue(value: LanguageValues | null) {
        this._value = value;
        if(value === null) {
            super.setValue(this._value);
            return this._input.setVal(null);
        }
        
        let fetchValue = value[this._selectedLanguage];
        this._input.setVal(fetchValue || "");
        super.setValue(this._value);
    }
    getValue(): LanguageValues | null {
        return this._value;
    }
    async remove(removeInner = true) {
        await super.remove(removeInner);
    }
}